import React from "react";
import styled from "styled-components";
import { bool, func, string } from "prop-types";

const StyledButton = styled.button`
  background: ${({ background, theme }) => theme.colors[background]};
  color: ${({ textColour, theme }) => theme.colors[textColour]};
  margin: ${({ margin }) => margin};
  width: ${({ width }) => width};
  border-radius: 4rem;
  font-size: ${({ size }) => size};
  padding: ${({ padding }) => padding || "0.3rem"};
  transform: translateY(0);
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600;
  border: none;
  outline: none;

  &:hover,
  &:focus {
    box-shadow: ${({ noAnimation }) =>
      !noAnimation && "0 1px 6px 0 rgba(0, 0, 0, 0.4)"};
    transform: ${({ noAnimation }) => !noAnimation && "translateY(-2px)"};
  }

  :disabled {
    background: #dad8d6;
    &:hover,
    &:focus {
      box-shadow: none;
      transform: none;
    }
  }
`;

const Button = ({
  background = "blue",
  className,
  disabled,
  label,
  margin,
  noAnimation,
  onClick,
  padding,
  size = "0.9rem",
  textColour = "white",
  type = "button",
  width
}) => (
  <StyledButton
    background={background}
    className={className}
    disabled={disabled}
    margin={margin}
    noAnimation={noAnimation}
    onClick={onClick}
    padding={padding}
    size={size}
    textColour={textColour}
    type={type}
    width={width}
  >
    {label}
  </StyledButton>
);

Button.propTypes = {
  background: string,
  className: string,
  disabled: bool,
  label: string.isRequired,
  margin: string,
  noAnimation: bool,
  onClick: func,
  padding: string,
  size: string,
  textColour: string,
  type: string,
  width: string
};

export default Button;
